import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const CONFIG = {
  lead: { title: "Add Lead", fields: [["company", "Company", true], ["contact_name", "Contact person"], ["phone", "Phone"], ["email", "Email"], ["industry", "Industry"]] },
  call: { title: "Record Call", type: "call", fields: [["notes", "Notes"], ["outcome", "Outcome"]] },
  visit: { title: "Record Visit", type: "visit", fields: [["notes", "Notes"], ["location", "Location"], ["outcome", "Outcome"]] },
  meeting: { title: "Record Meeting", fields: [["notes", "Notes"], ["scheduled_at", "When (optional)"]] },
  sale: { title: "Record Sale", fields: [["deal_value", "Deal value", true], ["currency", "Currency"], ["notes", "Notes"]] },
};

export default function QuickActionModal({ action, onClose, onDone }) {
  const [form, setForm] = useState({ currency: "INR" });
  useEffect(() => { setForm({ currency: "INR" }); }, [action]);
  if (!action) return null;
  const cfg = CONFIG[action];

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (action === "lead") await api.post("/leads", { company: form.company, contact_name: form.contact_name, phone: form.phone, email: form.email, industry: form.industry });
      if (action === "call" || action === "visit") await api.post("/activities", { type: cfg.type, notes: form.notes, outcome: form.outcome, location: form.location });
      if (action === "meeting") await api.post("/meetings", { notes: form.notes, scheduled_at: form.scheduled_at || null });
      if (action === "sale") await api.post("/sales", { deal_value: Number(form.deal_value), currency: form.currency || "INR", notes: form.notes });
      toast.success(`${cfg.title} saved`);
      onDone && onDone(); onClose();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/50" onClick={onClose}>
      <div className="w-full sm:max-w-md bg-white rounded-t-3xl sm:rounded-3xl p-6 pb-8" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-head text-xl font-bold text-[#0A1128]">{cfg.title}</h3>
          <button onClick={onClose} data-testid="qa-close" className="text-slate-400"><X size={22} /></button>
        </div>
        <form onSubmit={submit} className="space-y-3">
          {cfg.fields.map(([key, label, req]) => (
            <div key={key}>
              <label className="text-sm font-medium text-slate-600">{label}</label>
              <input required={req} data-testid={`qa-${key}`} value={form[key] || (key === "currency" ? "INR" : "")}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#1D4ED8] outline-none" />
            </div>
          ))}
          <button data-testid="qa-submit" className="w-full py-3.5 rounded-xl bg-[#1D4ED8] text-white font-semibold text-lg">Save</button>
        </form>
      </div>
    </div>
  );
}
